






































import { Component, Prop, Vue } from 'vue-property-decorator'
import Event from '@/models/Event'
import Artist from '@/models/Artist'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
  },
})
export default class Events extends Vue {
  @Prop() private events!: Event[]
  @Prop() private artists!: Artist[]

  // label
  filterLabel: string = 'Find your artist'
  errorMessageNoEvents: string = '– No shows available at the moment. –'
  errorMessageNoMatches: string = '– no match –'
  filteredEvents: Event[] = []
  filteredArtists: Artist[] = []
  searchTerm: string = ''
  isAutoCompleteOpen: boolean = false

  // computed
  get searchClasses(): any[] {
    return [
      'search',
      { 'search--active': this.isAutoCompleteOpen },
    ]
  }

  // methods
  onChange() {
    if (this.searchTerm.length === 0) {
      this.filteredEvents = this.events
      this.isAutoCompleteOpen = false
    } else {
      const mySearch: string = this.searchTerm.toLowerCase()
      const regex = RegExp(`(^${mySearch})|( ${mySearch})`)
      const matches = (artist: Artist) => regex.test(artist.title.toLowerCase())
      this.filteredArtists = this.artists.filter(matches)
      this.isAutoCompleteOpen = true
    }
  }

  setSearchTerm(artist: Artist) {
    this.filteredEvents = this.events.filter(event => event.artist.id === artist.id)
    this.searchTerm = artist.title
    this.isAutoCompleteOpen = false
  }

  clearSearch() {
    this.filteredEvents = this.events
    this.searchTerm = ''
    this.isAutoCompleteOpen = false
  }

  // livecycle
  created() {
    this.filteredEvents = this.events
  }
}
